import { combineReducers } from "redux";

import list from "./List/reducer";

const qrCodesReducer = combineReducers({
  list,
});

export default qrCodesReducer;
